import { QueryLineItem, searchHistoryItem } from "../models/db";
import { entrezConfig } from "./entrezConfig";

export function convertFirstCharToCaps(str: string) {
  try {
    if (str.length === 3) {
      return str.toUpperCase();
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  } catch (error) {
    console.log("convertFirstCharToCaps: Inside the catch");
    console.log(error);
  }
  return str;
}

export function getRetStart(page: number, pageSize: number) {
  console.log("page number:" + page + ", pagesize: " + pageSize);
  return (page - 1) * pageSize;
}

export function mergeNewQueryItem(
  queries: QueryLineItem[],
  newQueryItem: QueryLineItem
) {
  console.log(queries);

  //find None field
  var existingNoneField = undefined;
  if (newQueryItem.field === entrezConfig.FieldAsNone) {
    existingNoneField = queries.find(
      (qItem) => qItem.field === newQueryItem.field
    );
  }

  //check for operator applied. If not then set to "AND"
  if (queries.length >= 1) {
    if (newQueryItem.field !== entrezConfig.FieldAsNone) {
      newQueryItem.op =
        newQueryItem.op === "" ? entrezConfig.Operators[0] : newQueryItem.op;
    }
  }

  var updatedQueries = [];
  var queryArr: QueryLineItem[] = [newQueryItem];

  if (!existingNoneField) {
    updatedQueries = [...queries, ...queryArr];
  } else {
    updatedQueries = [
      ...queries.filter((q) => q.field !== newQueryItem.field),
      ...queryArr,
    ];

    // for (var i = 0; i < queries.length; i++) {
    //   if (queries[i].field === newQueryItem.field) {
    //     queries[i].term = newQueryItem.term;
    //     break;
    //   }
    // }

    // setQueries((prevState) => [...prevState]);
    // updatedQueries = queries;
    console.log("field is not None, so adding a new entry.");
  }

  return updatedQueries;
}

export function queryTermFormatter(queries: QueryLineItem[]) {
  var query = "";

  console.log(queries);

  if (queries.length <= 0) {
    return query;
  }

  //get the "first term"
  for (var i = 0; i < queries.length; i++) {
    const firstTerm = queries[i];
    if (firstTerm.field === entrezConfig.FieldAsNone) {
      query = firstTerm.term; //browser itself encode the terms to
      if (i !== 0 && queries[0].op.length <= 0) {
        query = query + " " + entrezConfig.Operators[0];
      }
      break;
    }
  }

  //for rest of fields
  for (i = 0; i < queries.length; i++) {
    const nextTerm = queries[i];

    if (nextTerm.field !== "None") {
      query =
        query +
        (query.length > 0 ? " " : "") +
        (query.length > 0 ? nextTerm.op : "") +
        (query.length > 0 && nextTerm.op.length > 0 ? " " : "") +
        nextTerm.term;
    }
  }

  console.log("formatted query term is");
  console.log(query);
  return query;
}

export function mergeSearcHistory(
  lastHistory: searchHistoryItem[],
  newHistory: searchHistoryItem
) {
  // var isExisting = false;

  // for (var i = 0; i < lastHistory.length; i++) {
  //   if (lastHistory[i].formattedSearchTerm === newHistory.formattedSearchTerm) {
  //     isExisting = true;
  //     break;
  //   }
  // }

  // var searchHistory = [...lastHistory];

  // if (!isExisting) {
  //   // add new one
  //   if (searchHistory.length >= entrezConfig.SearchHistoryCount) {
  //     //pop the last item out
  //     searchHistory.pop();
  //   }

  var searchHistory = [
    newHistory,
    ...lastHistory.filter(
      (history) =>
        history.formattedSearchTerm !== newHistory.formattedSearchTerm
    ),
  ];
  // }

  return searchHistory;
}
